import Device from '../../../../../../../constants/deviceSizes';

export default {
  container: {
    height: '100%',
    width: '100%',
    textAlign: 'justify'
  },
  field: {
    background: 'transparent',
    padding: '35px 40px 0',
    display: 'flex',
    flexDirection: 'column',
    [Device.mobile]: {
      padding: '25px 10px 0'
    }
  },
  button: {
    display: 'flex',
    alignItems: 'flex-start',
    margin: '25px 40px 0',
    [Device.mobile]: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 25
    }
  },
  tittleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: 30
  }
};
